const routes = [
    // 监课管理路由
    {
      path: "/foreignRegulatory",
      name: "foreignRegulatory",
      meta: {
        title: "监课管理",
        volcengine: true
      },
      component: () => import("@/pages/lsForeign/foreignRegulatory/index.vue")
    },
  ];
  export default routes;
  